import React, { useState } from "react";
import VideoData from "../../Sections/VideoGallery/VideoData";
import VideoItem from "../../Sections/VideoGallery/VideoItem";
import VideoModal from "../../Sections/VideoGallery/VideoModal";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import SwiperCore, { FreeMode } from "swiper";
import "swiper/swiper.scss";
SwiperCore.use([FreeMode]);
function VideoItems(props) {
  const [videoModal, setVideoModal] = useState({ visible: false, url: "" });
  const setVideoModalStatus = (visible = false, url = "") =>
    setVideoModal({ visible: visible, url: url });

  return (
    <>
      <Swiper
        loop={true}
        centeredSlides={true}
        breakpoints={{
          200: {
            slidesPerView: 2,
          },
          360: {
            slidesPerView: 2,
          },
          500: {
            slidesPerView: 3,
          },
          700: {
            slidesPerView: 4,
          },
          900: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 5,
          },
          1700: {
            slidesPerView: 6,
          },
          1920: {
            slidesPerView: 6,
          },
          2100: {
            slidesPerView: 7,
          },
        }}
      >
        {VideoData.map((item, index) => {
          return (
            <SwiperSlide key={`${item.videoUrl}_${index}`}>
              <VideoItem
                key={index}
                isservice={true}
                data={item}
                onPlay={() => setVideoModalStatus(true, item.videoUrl)}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
      {videoModal.visible ? (
        <VideoModal
          url={videoModal.url}
          onClose={() => setVideoModalStatus(false)}
        />
      ) : (
        ""
      )}
    </>
  );
}
export default VideoItems;
